import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import { freezePayment, getLink } from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const AddLink = ({ linkModal, setLinkModal, clientInfo, payload }) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);
  const yesterdayDate = dayjs().subtract(1, "day").format("DD.MM.YYYY");
  // STORE
  const abonementsList = useSelector(
    (state) => state.ClientsSlice.abonementsList
  );
  const clientAbonements = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientList
  );

  const clientFullAbonements =
    clientAbonements?.data?.value?.rows.map((row) => ({
      value: row.id,
      label: `${row.clubName}`,
    })) || [];
  // STATE
  const [abonementClubId, setAbonementClubId] = useState(null);
  const [defPurch, setDefPurch] = useState(false);
  const [from, setFrom] = useState(dayjs());
  const [to, setTo] = useState(dayjs());
  const [useStop, setUseStop] = useState();
  const [addStop, setAddStop] = useState();
  const [price, setPrice] = useState();
  const [selectedOpt, setSelectedOpt] = useState("VTB(ТЕСТ)");
  const [modeAdd, setModeAdd] = useState(false); //false - ссылка без заморозки, true - с заморозкой

  const payOptions = [{ value: "VTB(ТЕСТ)" }, { value: "CLOUDPAYMENT" }];
  const yesNoOpt = [
    { value: true, label: "Да" },
    { value: false, label: "Нет" },
  ];
  // FUNCTIONS
  const onClickAddLink = () => {
    if (!modeAdd) {
      dispatch(
        getLink({
          flag: "post",
          method: selectedOpt,
          value: {
            userId: clientInfo.id,
            abonementClubsId: abonementClubId,
            endDate: to ? to.add(3, "hour") : undefined,
            usedFrozenDays: useStop,
            addedFrozenDays: addStop,
            price: price,
            defferedDaysCount: defPurch
              ? Math.ceil(from.diff(dayjs(), "day", true))
              : 0,
          },
        })
      ).then(() => {
        dispatch(getLink({ flag: "get", value: { userId: clientInfo.id } }));
        dispatch(getClientsList(payload));
        setLinkModal(false);
        setFrom(dayjs());
      });
    } else {
      dispatch(
        freezePayment({
          method: selectedOpt,
          value: {
            userId: clientInfo.id,
            userAbonementId: abonementClubId,
          },
        })
      ).then(() => {
        dispatch(getLink({ flag: "get", value: { userId: clientInfo?.id } }));
        dispatch(getClientsList(payload));
        setLinkModal(false);
        setFrom(dayjs());
      });
    }
  };

  useEffect(() => {
    // dispatch(getClubs());
    setAbonementClubId();
  }, [linkModal]);
  
  return (
    <CModal
      alignment="center"
      visible={linkModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setLinkModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Добавить ссылку"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            {/* <Typography.Title level={5}>
              Добавление дней заморозки
            </Typography.Title>
            <div>
              <Select
                style={{ width: "100%" }}
                options={yesNoOpt}
                onChange={(e) => setModeAdd(e)}
                value={modeAdd}
                placeholder={`Выбрать`}
              />
              {console.log(modeAdd)}
            </div> */}
            <div>
              <Typography.Title level={5}>Метод оплаты</Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={payOptions}
                onChange={(value) => {
                  setSelectedOpt(value);
                }}
                placeholder={"Выбрать"}
                value={selectedOpt}
              />
            </div>
            {!modeAdd ? (
              <>
                <div>
                  <Typography.Title level={5}>Абонементы</Typography.Title>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    optionFilterProp="label"
                    options={abonementsList?.data?.value}
                    onChange={(value, opt) => {
                      setAbonementClubId(value);
                      setDefPurch(opt.deffered_purchase_allowed);
                      setPrice(opt.abonementPrice);
                      
                      let months = Number(opt.monthCount);
                      if (months > 0) {
                        setTo(dayjs(from).add(months, "month"));
                      } else {
                        setTo(dayjs(from).add(1, "hour")); // or whatever your fallback logic is
                      }
                    }}
                    placeholder={"Выбрать"}
                    value={abonementClubId}
                  />
                </div>

                <div>
                  <Typography.Title level={5}>Дата начала</Typography.Title>
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD.MM.YYYY"}
                    placement={"topRight"}
                    onChange={(date, dateString) => {
                      setFrom(date);

                      let selected = abonementsList?.data?.value.find(
                        (a) => a.value == abonementClubId
                      );
                      
                      let months = selected ? Number(selected.monthCount) : 0;
                      if (months > 0) {
                        setTo(dayjs(date).add(months, "month"));
                      } else {
                        setTo(dayjs(date).add(1, "hour"));
                      }
                    }}
                    value={from && dayjs(from)}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Дата конца</Typography.Title>
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD.MM.YYYY"}
                    placement={"topRight"}
                    value={to && dayjs(to)}
                    disabled
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Использованные замороженные дни
                  </Typography.Title>
                  <Input
                    defaultValue=""
                    type="number"
                    value={useStop}
                    onChange={(e) => {
                      setUseStop(e.currentTarget.value);
                    }}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>
                    Добавленные замороженные дни
                  </Typography.Title>
                  <Input
                    defaultValue=""
                    type="number"
                    value={addStop}
                    onChange={(e) => {
                      setAddStop(e.currentTarget.value);
                    }}
                  />
                </div>
                <div>
                  <Typography.Title level={5}>Цена</Typography.Title>
                  <Input
                    defaultValue=""
                    type="number"
                    value={price}
                    onChange={(e) => {
                      setPrice(e.currentTarget.value);
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <Typography.Title level={5}>Абонементы</Typography.Title>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    optionFilterProp="label"
                    options={clientFullAbonements}
                    onChange={(value) => {
                      setAbonementClubId(value);
                    }}
                    placeholder={"Выбрать"}
                    value={abonementClubId}
                  />
                </div>
              </>
            )}
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setLinkModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddLink} style={{ color: "#fff" }}>
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddLink;
